import { AxiosError } from "axios"
import type { APIErrorResponse } from "../types";

const extractAPIErrorMessage = (error: unknown): string | null => {
    if (error instanceof AxiosError) {
        if (error.response) {
            const responseData = error.response?.data;

            if (responseData.message) {
                return responseData.message
            }

            if (responseData.error) {
                return responseData.error
            }
        } else {
            return "Network Error"
        }
    } else if (error instanceof Error) {
        return error.message
    }

    return null;
}

export const buildErrorResponse = (mainMessage: string, error: unknown): APIErrorResponse => {
    const errorMessage = extractAPIErrorMessage(error);

    let message = mainMessage;

    if (errorMessage) {
        message += ` - ${errorMessage}`
    }

    return {
        ok: false,
        error: message,
    }
}
